import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useI18n } from "../i18n";

const ContactPage = () => {
  const { t } = useI18n();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Appel de l'API route Vercel
      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || t.contactPage.error);
      }

      toast.success(t.contactPage.success);
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Erreur détaillée:", error);
      toast.error(`${t.contactPage.error}: ${error.message}`);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      {/* Le <NavForPages /> qui était ici ajoutait un second <nav> à la page
          d'accueil ; smoothScroll() mesure document.querySelector('nav') et
          tombait donc sur le mauvais. Retiré. */}
      <section className="page" id="contact">
        <div className="page-center contact-page">
          {/* title */}
          <div className="section-title page-title">
            <h2>
              <span>{t.contactPage.title}</span>
            </h2>
            <div className="underline"></div>
            <p>
              {t.contactPage.intro}
              <br />
              {t.contactPage.or}{" "}
              <a href="mailto:nkenguestephane0@gmail.com">
                nkenguestephane0@gmail.com
              </a>
            </p>
          </div>

          {/* form */}
          <div className="section-center">
            <form className="form" method="POST" onSubmit={handleSubmit}>
              <div className="form-center">
                {/* name  */}
                <article>
                  <label htmlFor="name">{t.contactPage.name}</label>
                  <br />
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    name="name"
                    placeholder={t.contactPage.namePlaceholder}
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </article>
                {/* email */}
                <article>
                  <label htmlFor="email">{t.contactPage.email}</label>
                  <br />
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    name="email"
                    placeholder={t.contactPage.emailPlaceholder}
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </article>
                {/* text area */}
                <article>
                  <label htmlFor="message">{t.contactPage.message}</label>
                  <br />
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    placeholder={t.contactPage.messagePlaceholder}
                    rows="8"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </article>
              </div>
              <div className="btn-container">
                <button className="btn submit-btn" type="submit">
                  {t.contactPage.submit} <FaArrowRight className="fa" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
